import React from 'react';
import { useDialogState } from '@lialo/pwa-ui/lib/useDialogState';
import { DiscountCodeInfo } from '../../../common/models/code-info';
import { RedeemCouponDialog } from './RedeemCouponDialog';
import { RedeemCouponButton } from './RedeemCouponButton';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  onSuccess: (discountCodeInfo: DiscountCodeInfo) => void;
  onClear: () => void;
  shortLink: string;
  activeCode?: string;
}

export const RedeemCoupon = ({ shortLink, onSuccess, onClear, activeCode }: Props) => {
  const { t } = useTranslation();

  const [isOpen, openDialog, closeDialog] = useDialogState(
    (discountCodeInfo?: DiscountCodeInfo) => discountCodeInfo && onSuccess(discountCodeInfo)
  );

  return (
    <>
      <Typography sx={{ marginTop: 1.5 }} variant={'body1'} component={'h3'}>
        {t('checkout.coupon.coupon_headline')}
      </Typography>
      <RedeemCouponButton onClick={openDialog} onClear={onClear} activeCode={activeCode} />
      {isOpen && <RedeemCouponDialog onClose={closeDialog} shortLink={shortLink} />}
    </>
  );
};
